import type { SlotSymbolDef } from '../../widgets/slot/types';
import type { WheelSegment } from '../../widgets/wheel/types';
import type { Theme } from '../Theme';

const SYMBOLS: readonly SlotSymbolDef[] = [
  { id: 'cherry', glyph: '🍑', tint: 0xff8a3d, weight: 5 },
  { id: 'lemon', glyph: '🌅', tint: 0xffb85c, weight: 5 },
  { id: 'orange', glyph: '🌴', tint: 0xff6b3d, weight: 4 },
  { id: 'bell', glyph: '🦩', tint: 0xff3b6b, weight: 3 },
  { id: 'star', glyph: '⭐', tint: 0xffe28a, weight: 2 }, // wild
  { id: 'seven', glyph: '🌺', tint: 0xff5252, weight: 1 },
  { id: 'gem', glyph: '🍹', tint: 0xff48a0, weight: 1 },
  { id: 'scatter', glyph: '🌊', tint: 0xff8a3d, weight: 1 }, // scatter
  // Money symbol — golden sun reads as "treasure" against the dusk
  // palette without colliding with the cocktail "gem" glyph. Weight
  // + trigger tuned for demo (see defaultTheme money entry).
  { id: 'money', glyph: '☀️', tint: 0xc8841f, weight: 1.5, isMoney: true },
];

const SEGMENTS: readonly WheelSegment[] = [
  { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xffb85c, multiplier: 1, weight: 4 },
  { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xff8a3d, multiplier: 2, weight: 3 },
  { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x4a1a30, multiplier: 0, weight: 2 },
  { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xff48a0, multiplier: 3, weight: 2 },
  { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xffb85c, multiplier: 1, weight: 3 },
  { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xff5252, multiplier: 5, weight: 1 },
  { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x4a1a30, multiplier: 0, weight: 2 },
  { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xffe28a, multiplier: 10, weight: 1 },
  { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xff8a3d, multiplier: 2, weight: 3 },
  { id: 'x1-c', kind: 'multiplier', label: '×1', tint: 0xffb85c, multiplier: 1, weight: 3 },
  { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xff48a0, multiplier: 3, weight: 2 },
  { id: 'jackpot', kind: 'multiplier', label: '×25', tint: 0xff3b6b, multiplier: 25, weight: 1 },
];

/**
 * Sunset theme — warm orange/coral/pink palette evoking a beach-bar dusk.
 * Premium: locked behind a 10-gem unlock in the gem shop. The first
 * content gate that gives the level / XP / gem economy an actual reward
 * to chase.
 */
export const SUNSET_THEME: Theme = {
  id: 'sunset',
  name: 'Sunset',
  palette: {
    accent: 0xff48a0,         // hot coral pink
    secondary: 0xff8a3d,      // warm orange
    warm: 0xffe28a,           // golden hour
    frameFill: 0x3a1020,      // deep maroon
    bgGradientTop: 0xff6b3d,  // sunset orange
    bgGradientBottom: 0x6a1d3a, // dusk purple
    dimOverlay: 0x1a0810,
  },
  slot: {
    symbols: SYMBOLS,
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: SEGMENTS,
  },
};
